module.exports = __webpack_public_path__ + "static/media/close.9db99ea6.png";